import React, { useContext } from "react";

import { ActionDropdown } from "../ActionDropdown/ActionDropdown";
import {
  roles,
  statusPrestationsValues,
  subRoles,
  subStatus,
} from "../../../utils/constants";
import { ActionRoleSpecific, onlyRoleMapping } from "../../../engine/AuthRoute";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Button, notification } from "antd";
import { RiDeleteBinLine, RiMailSendLine } from "react-icons/ri";
import { MdPublishedWithChanges } from "react-icons/md";
import { FcCancel } from "react-icons/fc";
import {
  dangerousUpdate,
  deletePrestation,
  duplicatePrestation,
  setPropertiesPrestation,
  updatePrestation,
} from "../../../pages/Prestations/Slices/Prestation.slice";
import {
  confirmCancelPrestation,
  confirmDeletePrestation,
  confirmDuplicatePrestation,
  modalConfirmDeleteBill,
  modalModificationPrestationPending,
  modalsByContext,
} from "../Modals/modals";
import DownloadICS from "../DownloadICS/DownloadICS";
import dayjs from "../../../utils/dayjs";
import { UserContext } from "../../../engine/context/User.context";
import { BiDuplicate } from "react-icons/bi";
import { PrestationCancel } from "../Modals/PrestationCancel";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { TbPlayerTrackNextFilled } from "react-icons/tb";
import { FaRegFilePdf } from "react-icons/fa";
import useDocumentCreator from "../../../engine/hooks/useDocumentCreator";
import { http } from "../../../engine/api/http";
import { DeleteRowOutlined } from "@ant-design/icons";
import routes from "../../../engine/routes";

export const BillAction = ({}) => {
  const { bill, loading } = useSelector(state => state.bill);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useContext(UserContext);
  const context = useContext(ModalContext);
  const { id } = useParams();
  const [get, createAndGet, isLoading, setUrl, doc] = useDocumentCreator();

  const getPdf = () => {
    createAndGet({ bills: [id] }, `bills/${id}/pdf`, true, true, () => {
      console.log("callback done");
    });
  };

  const deleteBill = async () => {
    const showModalDelete = await new Promise((resolve, reject) => {
      modalConfirmDeleteBill({
        onOk: async () => {
          resolve(true);
        },
        onCancel: () => {
          reject(new Error("Update canceled."));
        },
      });
    });

    if (showModalDelete) {
      const res = await http.delete(`/bills/${id}`);
      notification.success({
        message: `Suppression confirmée`,
      });

      navigate(routes.billing().list.path, { replace: true });
    }
  };

  return (
    <ActionDropdown>
      <ActionRoleSpecific
        only={[roles.admin, roles.permanance, roles.institution]}
      >
        <span style={{ marginLeft: 5, marginRight: 10 }}>
          <RiMailSendLine color={"black"} size={18} />
        </span>
        <a onClick={() => {}}>Envoyer par email</a>
      </ActionRoleSpecific>
      <ActionRoleSpecific
        only={[roles.admin, roles.permanance, roles.institution]}
      >
        <span style={{ marginLeft: 5, marginRight: 10 }}>
          <FaRegFilePdf color={"black"} size={18} />
        </span>
        <a onClick={getPdf}>Télécharger la facture</a>
      </ActionRoleSpecific>
      <ActionRoleSpecific only={[roles.admin]}>
        <span style={{ marginLeft: 5, marginRight: 10 }}>
          <DeleteRowOutlined color={"black"} size={18} />
        </span>
        <a onClick={deleteBill}>Supprimer la facture</a>
      </ActionRoleSpecific>
    </ActionDropdown>
  );
};
